import logo from 'images/communities/NewOrleans/logo.svg'
import dashboardHeaderImage from 'images/communities/NewOrleans/banner.jpg'
import loginBackgroundImg from 'images/communities/NewOrleans/background-image.jpg'
import mapHeaderImage from 'images/communities/NewOrleans/landing.jpg'
import favicon from 'images/communities/NewOrleans/favicon.jpg'
import homeLogo from 'images/home/community-logos/new-orleans.png'
import { SURVEY_QUESTIONS } from 'types'
import videoImage from 'images/map/video/video-button-image.svg'

const config = {
  subdomain: 'neworleans',
  name: 'New Orleans',
  position: 4,
  partnerSupportEmail: 'artlooknola@artsedall.org',
  schoolSupportEmail: 'artlooknola@artsedall.org',
  artistSupportEmail: 'artlooknola@artsedall.org',
  stylesheet: 'new-orleans.scss',
  mapRedirectPath: '',
  organizationUrl: 'https://artsedall.org',
  faqUrl:
    'https://drive.google.com/file/d/1D4jBafcHqNqb37qTVdZuEjPXCCl3A1UX/view?usp=sharing',
  mapEnabled: true,
  schoolPortalEnabled: true,
  partnerPortalEnabled: true,
  partnerProfileCompletionEnabled: false,
  schoolProfileCompletionEnabled: false,
  teachingArtistProfileCompletionEnabled: false,
  showRecentLoginOnPublicPage: false,
  portalSignInEnabled: true,
  googleLoginEnabled: true,
  partnerProgramsEnabled: true,
  educatorEnabled: false,
  notificationsEnabled: true,
  notificationListSize: -1,
  dataDashboardEnabled: true,
  partnerRegisterEnabled: false,
  id: 9,
}

// ----- Teaching Artist -----
config.teachingArtist = {
  enabled: false,
  registerEnabled: false,
  provideOwnPrograms: false,
}

config.teachingArtistRegister = {
  fields: {
    firstName: {
      visible: true,
      required: true,
    },
    lastName: {
      visible: true,
      required: true,
    },
    email: {
      visible: true,
      required: true,
    },
    address: {
      visible: true,
      required: true,
    },
    yearsOfExperience: {
      visible: true,
      required: true,
    },
    description: {
      visible: true,
      required: true,
    },
    website: {
      visible: true,
      required: false,
    },
    disciplines: {
      visible: true,
      required: true,
    },
    profilePicture: {
      visible: true,
      required: false,
    },
    backgroundCheckFile: {
      visible: false,
      required: false,
    },
    pronouns: {
      visible: false,
      required: false,
    },
    demographic: {
      visible: false,
      required: false,
    },
    idealWage: {
      visible: true,
      required: false,
    },
  },
}

// ----- SEARCH -----
config.search = {
  options: {
    blockList: ['networks', 'creativeSchoolsCategory', 'schoolDistrict'],
  },
  schoolSearchFilters: [
    'network',
    'creativeSchoolsCategory',
    'instructorsTeaching',
    'schoolType',
    'organizationPartnersCount',
    'programsOffered',
    'disciplineInterests',
    'resourceProgramOutcomeInterests',
    'coursesOffered',
    'studentDemographics',
    'schoolDistrict',
    'openToPartnerships',
  ],
  map: {
    center: { lat: 30.0217523, lng: -89.9290514 },
  },
}

// ----- BRANDING -----

config.defaultBranding = {
  className: 'nola-community',
  favicon,
  mapLogo: {
    src: logo,
    alt: "New Orleans Arts Education Alliance's homepage",
    link: config.organizationUrl,
  },
  videoImpage: {
    src: videoImage,
    alt: 'Video Image',
  },
  homeLogo: {
    src: homeLogo,
    alt: 'New Orleans Arts Education Alliance',
  },
  communityLogo: {
    src: logo,
    alt: 'Artlook Schools',
  },
  dashboardHeader: {
    src: dashboardHeaderImage,
    alt: '',
  },
  loginBackgroundImg: {
    src: loginBackgroundImg,
    alt: '',
  },
  mapHero: {
    src: mapHeaderImage,
    alt: '',
  },
}

// ----- DISPLAY TEXT -----

/**
 * This object overrides the display text that is defined globally with string values that are
 * specific to the organization. Mustache-esque templating is available for dynamic strings using
 * {{ insertFieldName }} for interpolation.
 */

config.displayText = {
  map: {
    title: 'artlook Map: Increasing Arts Education in New Orleans',
    searchHeader: 'Find Schools & Partners in New Orleans',
    welcomeSearchHeader: 'Explore Arts Education in New Orleans',
    welcomeHeader: `
      How Does artlook Help Arts Education in <span>${config.name}<span>?
    `,
    explorationHeader:
      '<h1>What can you do on artlook<sup>®</sup> New Orleans</h1>',
    explorationSubTitle: 'Here are some examples...',
    welcomeMessage: `
      <div class="columns">
        <div class="column-left">
          <p>
           artlook<sup>®</sup> ${config.name} is a free online hub created to help educators in our region immerse 
           young people in powerful, personally relevant arts learning opportunities.  
          </p>
          <p>
            Developed by Ingenuity in Chicago and customized as a collaboration among local teachers, school and 
            district administrators, arts partners, and AEC staff, provides an up-to-date picture of the people, 
            places, and programs supporting arts learning in Southwestern Pennsylvania. 
          </p>
        </div>
        <div class="column-right">
          <p>
            In addition to the public Map and Directory available on this site, artlook<sup>®</sup> also enhances the 
            way that AEC is able to provide data analysis, reporting, and specialized programs to arts educators, 
            advocates, and funders with the goal of strengthening a diverse, robust arts education system in our region.  
          </p>
          <p>
            AEC invites additional schools and arts partners to join SWPA each year. Learn more about eligibility and 
            how to get on the map at <a href="${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">
            ${config.schoolSupportEmail}</a>
          </p>
        </div>
      </div>
    `,
    findSchoolsCard: `
      <p>
        If you’re an arts organization or teaching artist, search for schools in
        need of programs that you offer. Reach out!
      </p>

      <p>
        If you’re a parent looking for an arts-rich or discipline-specific
        school for your child, find schools that provide what you’re looking
        for.
      </p>
    `,
    findProgramsCard: `
      <p>
        If you’re a school in need of arts programs, partnerships, or resources,
        search for arts orgs that provide what you’re looking for. New arts ed
        partners are waiting to connect!
      </p>
    `,
    findDataCard: `
      <p>
        If you’re an advocate for a stronger, more vibrant arts education
        landscape in ${config.name}, reach out to Arts Ed Collaborative
        <a href="${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">
        ${config.schoolSupportEmail}</a>. We provide data, programming, and other opportunities aimed at strengthening 
        and expanding creative opportunities for our region’s students.
      </p>
    `,
    justExploreCard: `
      <p>
        The artlook<sup>®</sup> SWPA Map contains the most comprehensive picture of arts ed
        in our region - go search, explore, and learn more about the arts in our
        schools -- as well as where we need to bring more arts to more students.
      </p>
    `,
    videoWelcomeTitle: `Welcome To artlook<sup>®</sup> ${config.name}`,
    videoWelcomeMessage: `
      <p>
        This (free!) publicly-available and searchable map is the only one of its kind in Pennsylvania to capture information on arts education from schools, arts organizations, and teaching artists. Using the Search function below, you can explore the arts ed programs and resources available to students in schools and via partners throughout the region.      </p>
      <p>
        The Map and Directory provide an up-to-date picture of what’s happening in arts ed and where, as well as contact info to connect directly to these schools and arts organizations.  GO EXPLORE & CONNECT to bring more arts to more students!
      </p>
    `,
    videoModal: {
      width: '560',
      height: '315',
      srcUrl:
        'https://www.youtube.com/embed/OeqCbofkUi8?si=988vOCj6wdLTqNEW&amp;controls=0',
      iframeTitle: 'New Orleans artlook map welcome video',
    },
    footer: {
      learnMoreAboutArtlook: 'Learn more about artlook<sup>®</sup>',
      contact: "We'd love to hear from you",
    },
    metricScore: {
      title: 'Creative Schools Certification',
      message: `
        The Creative Schools Certification is at the core of the CPS
        Arts Education Plan. It is a summary measure of the quality
        of arts education available in each school, and therefore
        functions as a decision-making roadmap for stakeholders
        working to expand the arts in schools.
      `,
      basedOnSchoolYear:
        ' The Certification information here is based on the {{ schoolYearNumber }} school year.',
    },
  },
  surveyCompletionModal: `
    <h2>Survey Complete!</h2>
    <br />
    <p>Thank you for completing this year's survey! Your responses help us paint a more comprehensive picture of arts education and can help us connect public schools such as yourselves with quality arts programs. You can download a copy of your survey responses on the survey page.</p>
    <br />
    <p><b>Next up: Give your Profile a quick refresh! Update your current year data to make sure everything's spot-on. The more accurate your info, the easier it is to connect with new partners and get discovered by the right ones.</b></p>
  `,
  tagline:
    "Let's increase arts education access, equity, and quality in New Orleans.",
  partnerPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> New Orleans</em> is YOUR local hub for arts education</h3>
        <p>
          <em>artlook<sup>®</sup> New Orleans</em> is a unique, searchable platform that combines data from Orleans Parish public schools and arts education program providers (like you!) across the city. The goal is to increase partnerships and resources for arts providers and schools, and expand equitable access to quality arts education for EVERY student in our community.
        </p>
        <p>
          <strong>To get started, follow the links in the boxes below to share your organization's program and school partnership information. Make sure to complete all sections of your profile.</strong>
        </p>
        <p>
          If you have any questions or need assistance, please contact <a href="mailto:${config.partnerSupportEmail}" target="_blank" rel="noopener noreferrer">${config.partnerSupportEmail}</a>.
        </p>
      `,
    },
  },
  schoolPortal: {
    dashboard: {
      welcomeMessage: `
        <h3><em>artlook<sup>®</sup> New Orleans</em> is YOUR local hub for arts education</h3>
        <p>
          <em>artlook<sup>®</sup> New Orleans</em> is a unique, searchable platform that combines data from Orleans Parish public schools (like yours!) and arts education program providers across the city. The goal is to increase partnerships and resources for arts providers and schools, and expand equitable access to quality arts education for EVERY student in our community.
        </p>
        <p>
          <strong>To get started, complete both steps below: Update Your School Profile to share your partnership interests for the current school year, and Complete the Annual Survey (once it goes live) to share information about your school's arts education offerings from the previous school year.</strong>
        </p>
        <p>
          If you have any questions or need assistance, please contact <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a>.
        </p>
      `,
    },
  },
  survey: {
    getStarted: `
      <h2>Welcome to the {{ surveySchoolYearNumber }} artlook<sup>®</sup> Survey!</h2>
      <p>
        Through this annual survey, you will be asked to share information about arts education staffing and instruction at your school, partnerships with arts partners (i.e. arts organizations), and how your school budgets and plans for the arts.
      </p>
      <p>
        <strong>Because of learning disruptions and differing instructional formats in the 2019-20 school year we ask you to <em>only consider courses, programs, and arts instruction from the beginning of the school year through the closure of in-person instruction in March.</em></strong>
      </p>
      <p>
        As you work on the {{ surveySchoolYearNumber }} survey, please be sure to save your responses to each question to avoid losing information. You are not required to complete your survey in one session; so long as your question responses are saved, you can return at any time to edit your survey before submitting.
      </p>
      <p>
        Please feel free to reach out to <a href="mailto:${config.schoolSupportEmail}" target="_blank" rel="noopener noreferrer">${config.schoolSupportEmail}</a> with any questions.
      </p>
    `,
    staffingQuestion: {
      modalMessage: `
        <p>
          <strong>Note on instructors</strong>: Restrict the list of instructors in your school to those teaching an arts course during the school day. If itinerant teachers teach at your school, please report those individuals as well. If your school employs teaching artists as instructors, please report those individuals in the Community & Partnerships section of this survey.
        </p>
        <p>
          <strong>Note on part/full-time status</strong>: Please select Full Time if a teacher had full-time status at your school for the entire school year. If a teacher was part-time at your school for all or part of the year, or full-time for only part of the year, please select Part Time.
        </p>
        <p>
          <strong>Note on disciplines</strong>: The Primary Focus of each instructor is required. You may optionally list a Secondary Focus as well. Please also select the “Classroom/non-arts teacher?” button if the instructor is not primarily an arts instructor (e.g., non-arts, general education teacher teaching arts courses).
        </p>
      `,
      displayOptions: {
        showClassNumber: true,
      },
    },
    instructorQuestion: {
      displayOptions: {
        showInstructorEmail: true,
      },
    },
    scholarshipQuestion: {
      displayOptions: {
        showExample: true,
      },
    },
  },
  artistPortal: {
    dashboard: {
      welcomeMessage: `
        <h3>Welcome to artlook – A Home for Teaching Artists!</h3>
        <p>
          We're excited to have you join our vibrant community of teaching artists, educators, and organizations passionate about arts education. Whether you're here to showcase your talents, connect with schools and partners, or discover new opportunities, this platform is designed to support your journey
        </p>
        <p>
          Start by building your profile, sharing your experience, and exploring collaborations. Together, we can inspire creativity and make a lasting impact through the arts.
        </p>
        <p>
        If you have any questions or need assistance, please contact <a href="mailto:${config.artistSupportEmail}" target="_blank" rel="noopener noreferrer">${config.artistSupportEmail}</a>.
        </p>
      `,
    },
  },
}

// ----- SURVEY QUESTIONS CONFIG -----

const {
  APPROACHES,
  OBSTACLES_SELECT,
  OBSTACLES_DESCRIBE,
  OBSTACLES_OVERCOME,
  COMMUNITY_ENGAGEMENTS,
} = SURVEY_QUESTIONS

config.surveyQuestions = {
  approaches: APPROACHES.OPTIONS.PER_DISCIPLINE,
  obstaclesSelect: OBSTACLES_SELECT.OPTIONS.GENERAL,
  obstaclesDescribe: OBSTACLES_DESCRIBE.OPTIONS.GENERAL,
  obstaclesOvercome: OBSTACLES_OVERCOME.OPTIONS.GENERAL,
  communityEngagement: COMMUNITY_ENGAGEMENTS.OPTIONS.GENERAL,
}

export default config
